import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './button.module.css';
import Spinner from 'app/shared/spinners/spinner-15/spinner-15';
import { Icon } from 'assets/icons';

export const Button = ({
  className = '',
  icon_name = '',
  icon_position = 'before', // before | after
  text = '',
  onClick = () => {},
  type = 'primary', // 'primary' | 'secondary'
  loading,
  disabled = false,
  stop_count = false,
  delay_interval = 0
}) => {
  const [interval, setIntervalState] = useState(null);
  const [is_disabled, setIsDisabled] = useState(disabled || loading);
  const [ticker, setTicker] = useState(0);

  useEffect(() => {
    setIsDisabled(disabled || loading);
  }, [disabled, loading]);

  useEffect(() => {
    if (stop_count) {
      clearInterval(interval);
      setTicker(0);
    }
  }, [stop_count]);

  const btn_type = `btn_${type}`;

  const handleClick = () => {
    if (delay_interval) {
      setIsDisabled(true);
      setTicker(delay_interval / 1000);

      const interval = setInterval(() => {
        setTicker((prev) => prev - 1);
      }, 1000);

      setIntervalState(interval);

      setTimeout(() => {
        clearInterval(interval);
        onClick();
        setIsDisabled(false);
      }, delay_interval);
    }

    onClick();
  };

  return (
    <button
      className={cx(styles.button, !icon_name ? styles.padding : '', styles[btn_type], className)}
      onClick={(e) => {
        e.preventDefault();
        handleClick();
      }}
      disabled={is_disabled || ticker > 0}
    >
      {icon_name && icon_position === 'before' && (
        <span className={styles.icon}>
          {' '}
          <Icon width={20} height={20} name={icon_name} />{' '}
        </span>
      )}
      {text && (
        <span className={styles.text}>
          {text} {!loading && ticker > 0 && `(${ticker})`}
        </span>
      )}
      {!loading && icon_name && icon_position === 'after' && (
        <span className={styles.icon}>
          {' '}
          <Icon width={20} height={20} name={icon_name} />{' '}
        </span>
      )}
      {loading && (
        <span className={styles.spinner}>
          <Spinner />
        </span>
      )}
    </button>
  );
};

export const LinkButton = ({ className = '', text = '', onClick = () => {} }) => (
  <button className={cx(styles.link_button, className)} onClick={onClick}>
    {text}
  </button>
);
